var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-img',_vm._g(_vm._b({staticClass:"d-inline-block mr-8 mb-4",attrs:{"contain":"","src":_vm.src,"alt":_vm.name,"width":(_vm.size + "px"),"height":(_vm.size + "px")}},'v-img',attrs,false),on))]}}])},[_c('span',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }